import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideTranslateService, TranslateModule } from '@ngx-translate/core';
import { LandingRoutingModule } from './landing-routing.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DependencyModule } from '../core/modules/dependency.module';
import { MaterialModule } from '../core/modules/material.module';

export const LANDING_CONFIG: ApplicationConfig = {
	providers: [
		{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: { showDelay: 200, disableTooltipInteractivity: true } },
		provideHttpClient(withInterceptorsFromDi()),
		provideTranslateService({
			lang: 'en',
			fallbackLang: 'en',
			loader: provideTranslateHttpLoader({
				prefix: '/locales/',
				suffix: '.json'
			})
		}),
		importProvidersFrom(LandingRoutingModule, CommonModule, RouterModule, DependencyModule, TranslateModule, MaterialModule)
	],
};